/* eslint-disable no-lone-blocks */


import { useRef, useState } from "react";

import { Dropdown, TextInput } from "../../../../../shared/ui/common/index.js";
import { genderData } from "../../../../../shared/lib/constants.js";
const UserInfo = ({ userData, setUserData, id, access }) => {
  const [startTime, setstartTime] = useState();
  const startTimeCalender = useRef();
  const [valueStatDate, setValueStatDate] = useState(0);

  function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? "+" : "-",
      pad = function (num) {
        return (num < 10 ? "0" : "") + num;
      };
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      "00" +
      ":" +
      "00" +
      ":" +
      "00"
    );
  }
  return (
    <div className="flex flex-col md:grid lg:grid-cols-4 md:grid-cols-3 pt-10 px-5  gap-4 relative z-10">
      <>
        <TextInput
          label="نام"
          currentValue={userData?.fname}
          change={(e) => setUserData({ ...userData, fname: e })}
        />
      </>
      <>
        <TextInput
          label="نام خانوادگی"
          currentValue={userData?.lname}
          change={(e) => setUserData({ ...userData, lname: e })}
        />
      </>
      <>
        <TextInput
          label="شماره موبایل"
          currentValue={userData?.mobile}
          change={(e) => setUserData({ ...userData, mobile: e })}
        />
      </>

      <div>
        <TextInput
          label="ایمیل"
          currentValue={userData?.email}
          change={(e) => setUserData({ ...userData, email: e })}
        />
      </div>
{/*       <div>
        <TextInput
          label="کد ملی"
          currentValue={userData?.nationalCode}
          change={(e) => setUserData({ ...userData, nationalCode: e })}
        />
      </div> */}


      <div>
        <Dropdown
          value={userData?.isMale ? "مرد" : "زن"}
          change={(e) => setUserData({ ...userData, isMale: e === "مرد" })}
          data={genderData}
          title="جنسیت"
        />
      </div>
      <div className="md:col-span-3">
        <TextInput
          label="آدرس"
          currentValue={userData?.address}
          change={(e) => setUserData({ ...userData, address: e })}
        />
      </div>



      <div className="flex items-end gap-5 col-span-3 userInput"></div>
    </div>
  );
};

export default UserInfo;
